import { Outlet, Navigate } from 'react-router-dom';

const ProtectedRoute = () => {
  const raw = localStorage.getItem('token');
  if (!raw || raw === 'undefined' || raw === 'null') {
    if (raw) localStorage.removeItem('token');
    return <Navigate to={'/europa/login'} replace />
  }
  return <Outlet />
}

export default ProtectedRoute;
